/**
 * The site CSP forbids eval. zod v4 otherwise probes `new Function` the first time it builds an
 * object schema (every game engine does at import time), which logs a CSP violation. Imported first
 * by the app entry so it runs before any engine chunk.
 */
import { z } from "zod";

z.config({ jitless: true });
